export default __webpack_public_path__ + "static/media/delete-icon.b840bef3.svg";